<template>
  <div :class="{disabled: isDisabled}">
    <input
      type="checkbox"
      :id="name"
      :value="value"
      :disabled="isDisabled"
      @change="handleChange"/>
    <label :for="name">
      <checkbox-empty v-if="!value" />
      <checkbox-selected v-if="value" />
      <span v-show="label" v-html="label"></span>
    </label>
    <span v-if="error" class="error">{{ error }}</span>
  </div>
</template>

<script>
import CheckboxEmpty from '../assets/icons/checkbox-empty.svg?inline'
import CheckboxSelected from '../assets/icons/checkbox-selected.svg?inline'

export default {
  name: 'app-checkbox',
  components: {
    CheckboxEmpty,
    CheckboxSelected,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    value: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    error: {
      type: String,
      default: '',
    },
  },
  methods: {
    handleChange () {
      this.$emit('change', {value: !this.value, name: this.name})
    },
  },
}
</script>

<style scoped>
div {
  display: inline-block;
  position: relative;
}
input[type="checkbox"] {
  display: none;
}
.disabled {
  color: #999;
}
.disabled svg {
  fill: #aaa;
}
label {
  display: inline-flex;
  font-weight: 400;
}
label svg {
  width: 20px;
  height: 20px;
  margin-right: 3px;
}
.error {
  color: red;
  font-size: 12px;
  background: transparent !important;
  position: absolute;
  left: 0;
  bottom: -15px;
}
</style>
